<template>
  <component :is="wrapper" v-if="parentEntryId !== undefined">
    <v-card-text>
      <p v-if="header" v-bind="header">{{ header.label }}</p>
    </v-card-text>
    <QueryTableWidget
      v-if="qid != null"
      v-model="selectedEntries"
      :query-id="qid"
      select-all
      :hard-filters="hardFilters"
      :show-delete-btn="showDeleteBtn"
    ></QueryTableWidget>
  </component>
</template>

<script>
import ApiService from '../APIService.js'

export default {
  components: {
    QueryTableWidget: () => import('../leaf_widgets/QueryTableWidget.vue')
  },
  props: {
    dismissCardView: {
      type: Boolean,
      default: false
    },
    entityId: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: false,
      default: null
    },
    header: {
      type: Object,
      default: null
    },
    queryId: {
      type: String,
      default: null
    },
    hardFilters: {
      type: Object,
      default: null
    },
    parentEntryId: {
      type: String,
      default: null
    },
    showDeleteBtn: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      qid: this.queryId || null,
      selectedEntries: this.value == null ? null : this.value.entries || null
    }
  },
  computed: {
    wrapper() {
      return this.dismissCardView == null || this.dismissCardView === false
        ? 'v-card'
        : 'div'
    }
  },
  watch: {
    selectedEntries() {
      if (this.selectedEntries == null || this.selectedEntries.size == 0) {
        this.$emit('input', null)
      } else {
        var selectedEntriesArray = []
        this.selectedEntries.forEach((val1) => {
          selectedEntriesArray.push(val1)
        })

        this.$emit('input', {
          entityId: this.entityId,
          entries: selectedEntriesArray
        })
      }
    }
  },
  created() {
    if (this.qid == null) {
      ApiService.getForm(this.entityId, 'list').then((res) => {
        if (res.status >= 200 && res.status <= 299) {
          this.qid = res.data.queryId
          this.updates++
        }
      })
    }
    console.log('Multi ref hard filters:')
    console.log(JSON.parse(JSON.stringify(this.hardFilters)))
  }
}
</script>
